module.exports = __webpack_public_path__ + "img/envelopamento5.bc728dea.jpg";